import { initializeAdvertisingIdentitySync } from '@/reporting/advertisingIdentitySync';
import { useEffect, useRef } from 'react';

/**
 * 在全局客户端首次挂载时非阻塞启动广告身份同步。
 */
export function useAdvertisingIdentitySync(): void {
  /** Strict Mode Effect 重放期间保留的单次启动标记。 */
  const didStartRef = useRef(false);

  useEffect(() => {
    if (didStartRef.current) return;

    didStartRef.current = true;
    void initializeAdvertisingIdentitySync();
  }, []);
}
